import styled, { css } from 'styled-components';

import { customMaxWidthMediaQuery } from '../../styles/constants';
import theme from '../../styles/theme';
import { TextAlignment } from '../../types/utils/alignment';
import {
  DefaultUnorderedListWrapperProps,
  StylesOverrideStyled,
  TypographyFontFamily,
} from './TypographyBlok.types';

export const getTextAlignmentValue = (textAlignment: TextAlignment) => {
  switch (textAlignment) {
    case 'left':
      return 'left';
    case 'center':
      return 'center';
    case 'right':
      return 'right';
  }
};

export const getFontFamilyValue = (fontFamily: TypographyFontFamily) => {
  switch (fontFamily) {
    case 'primary':
      return theme.fonts.fontFamily.primary;
    case 'secondary':
      return theme.fonts.fontFamily.secondary;
  }
};

export const StylesOverride = styled.div<StylesOverrideStyled>`
  display: inline;

  ${({ fullWidth }) =>
    fullWidth
      ? css`
          width: 100%;
        `
      : ''}

  .TypographyBlokContent,
  .TypographyBlokContent > * {
    ${({ theme }) => customMaxWidthMediaQuery(theme.breakpoints.xl)} {
      ${({ fontSizeMobile }) =>
        fontSizeMobile ? `font-size: ${fontSizeMobile}rem !important;` : ''}
      ${({ fontWeightMobile }) =>
        fontWeightMobile ? `font-weight: ${fontWeightMobile} !important;` : ''}
      ${({ lineHeightMobile }) =>
        lineHeightMobile ? `line-height: ${lineHeightMobile}rem !important;` : ''}
    }

    ${({ theme }) => theme.mediaQuery.xl} {
      ${({ fontSize }) => (fontSize ? `font-size: ${fontSize}rem !important;` : '')}
      ${({ fontWeight }) => (fontWeight ? `font-weight: ${fontWeight} !important;` : '')}
      ${({ lineHeight }) => (lineHeight ? `line-height: ${lineHeight}rem !important;` : '')}
    }

    ${({ textUnderlineOffset }) =>
      textUnderlineOffset ? `text-underline-offset: ${textUnderlineOffset}!important;` : ''}
    ${({ textDecorationThickness }) =>
      textDecorationThickness
        ? `text-decoration-thickness: ${textDecorationThickness} !important;`
        : ''}

    b {
      font-weight: ${({ theme }) => theme?.fonts.weight.medium} !important;
    }
  }

  p.TypographyBlokContent {
    :not(:first-child),
    :not(:last-child) {
      margin-bottom: 1.6rem;
    }
  }
`;

export const TypographyListItemWrapper = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  p {
    margin-bottom: 0px !important;
  }

  .list-icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
  }
`;

export const TypographyUnorderedListWrapper = styled.ul`
  padding-left: 0px;
  margin-left: 0px;
  list-style: none;
`;

export const DefaultUnorderedListWrapper = styled.ul<DefaultUnorderedListWrapperProps>`
  ${({ noPadding }) => (noPadding ? `padding: 1rem;` : 'unset')}
`;
